/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import { combineReducers } from "redux";
import appReducer from "./app";
import authReducer from "./auth";
import userReducer from "./user";
import adminReducer from "./admin";
import projectReducer from "./project";
import toolsReducer from "./tools";
import termsAndConditionsReducer from "./termsAndConditionsReducer";
import termsVersion from "./termsVersionReducer";
import uploadsReducer from "./uploads";
import filesReducer from "./files";
import companiesReducer from "./companies";

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  admin: adminReducer,
  user: userReducer,
  project: projectReducer,
  tools: toolsReducer,
  termsAndConditions: termsAndConditionsReducer,
  termsVersion: termsVersion,
  uploads: uploadsReducer,
  files: filesReducer,
  companies: companiesReducer,
});

export default rootReducer;
